import { useQuery } from "@tanstack/react-query";
import type { TrapPacketDto, TrapQueryDto } from "@gryzonie/shared";
import { api } from "../lib/api";

export type TrapPacketsQuery = Partial<TrapQueryDto>;

export function useTrapPackets(query: TrapPacketsQuery, autoRefresh: boolean = true) {
  return useQuery<TrapPacketDto[]>({
    queryKey: ["trap-packets", query],
    queryFn: () => {
      const params = new URLSearchParams();
      for (const [k, v] of Object.entries(query)) {
        if (v === undefined || v === null || v === "") continue;
        params.set(k, String(v));
      }
      return api<TrapPacketDto[]>(`/traps/packets?${params.toString()}`);
    },
    refetchInterval: autoRefresh ? 5000 : false,
    refetchIntervalInBackground: false,
  });
}
